import { FC } from 'react';
import Skeleton from '../presentational/skeleton';
import { TwoPaneContent } from '../presentational/layouts';
import SkeletonGuildPages from './SkeletonGuildPages';

const SkeletonGuildPageContainer: FC<any> = () => {
  return (
    <div>
      <Skeleton height={144} style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
        <div className="slds-p-horizontal--small">
          <Skeleton variant="item" width={300} height={31} margin="0 0 4px 0" animate />
          <Skeleton variant="item" width={150} height={19} animate />
        </div>
      </Skeleton>
      <TwoPaneContent>
        <>
          <Skeleton height={103} margin="0 0 24px 0" />

          <div style={{ display: 'flex', marginBottom: 24 }}>
            <Skeleton width={68} height={40} margin="0 4px 0 0" borderRadius="0.25rem" />
            <Skeleton width={89} height={40} margin="0 4px 0 0" borderRadius="0.25rem" />
            <Skeleton width={123} height={40} margin="0 4px 0 0" borderRadius="0.25rem" />
            <Skeleton width={174} height={40} margin="0 4px 0 0" borderRadius="0.25rem" />
          </div>

          <SkeletonGuildPages />
        </>
        <>
          <Skeleton height={208} />
          <div style={{ marginTop: 24 }}>
            <Skeleton height={23} />
            <Skeleton variant="item" height={288} animate />
          </div>
        </>
      </TwoPaneContent>
    </div>
  );
};

export default SkeletonGuildPageContainer;
